module.exports = "/_next/static/images/Display-23d51348345c9ab559904548c192f6ca.png";